// import KeyboardArrowLeftIcon from "@material-ui/icons/KeyboardArrowLeft";
// import KeyboardArrowRightIcon from "@material-ui/icons/KeyboardArrowRight";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { useState } from "react";
const slides = [
  {
    id: 1,
    heading: "TCF",
    para: `We continue to support TCF’s non-profit initiatives and activities, following the precedence 
    set by Saadia Awan as the founding member of The Citizens Foundation.`,
    img1: "/Home/image1.1.jpg",
    img2: "/Home/image2.1.jpg",
    img3: "/Home/image3.1.jpg",
  },
  {
    id: 2,
    heading: "Khadija School",
    para: `TCS prepared a futsal court for the underprivileged children of Khadija Kazi Ali Welfare Complex School. 
    The happiness on children’s faces is priceless.`,
    img1: "/Home/KhadijaImages/2.1.jpg",
    img2: "/Home/KhadijaImages/2.2.jpg",
    img3: "/Home/KhadijaImages/2.3.jpg",
  },
];
const RoleCsrComponent = () => {
  const [slide, setSlide] = useState({
    id: slides[0].id,
    heading: slides[0].heading,
    para: slides[0].para,
    heading: slides[0].heading,
    img1: slides[0].img1,
    img2: slides[0].img2,
    img3: slides[0].img3,
  });
  const next = () => {
    slide.id === slides.length
      ? setSlide(slides[0])
      : setSlide(slides[slide.id]);
  };
  const prev = () => {
    slide.id === 1
      ? setSlide(slides[slides.length - 1])
      : setSlide(slides[slide.id - 2]);
  };
  return (
    <div className="relative ">
      <div className="max-w-[70rem] mx-auto flex flex-col justify-center px-[2rem] sm:py-[4.2rem] py-[40px] text-[#373737]">
        <div className="flex flex-col lg:flex-row justify-center lg:gap-[8rem] md:gap-[10rem]">
          <div className="grid lg:max-w-[19rem] lg:mt-[1rem] md:w-[37rem] md:items-center md:justify-center md:mx-6 ">
            <div className="mb-[2rem]">
              <h1 className="react-reveal font-bold sm:text-4xl text-3xl lg:max-w-[23rem] lg:mr-[-5rem]">
                TCS's CSR Activities In Pakistan
              </h1>
              <hr className="react-reveal hr" />
            </div>
            <p className="react-reveal lg:my-4 md:my-1">
              As one of the largest logistics organisations in Pakistan, TCS is
              aware of its responsibility of giving back to the society. In
              fact, helping the less fortunate is one of the founding pillars of
              our organisation. Over the years, we have worked to build systems
              and programmes that allow us to do good for society and to provide
              assistance to the less fortunate whenever needed.
            </p>
          </div>

          <div className="flex-1  self-end max-w-[45rem] lg:mt-[2rem] md:mt-[unset] mt-[8rem]">
            <div className="bg-[#ED1C24] relative text-white lg:px-[2rem] md:px-[6rem] pb-[3rem] pt-[6rem] h-[18rem] md:h-[15rem]">
              <div className="relative flex gap-1 ">
                <div className="flex absolute justify-center md:justify-start left-[0] right-[0] top-[-11rem] sm:top-[-13.5rem]">
                  <img
                    src={slide.img1}
                    alt=""
                    className="w-[28%] object-contain"
                  />
                  <img
                    src={slide.img2}
                    alt=""
                    className="w-[35%] object-contain mx-[1%]"
                  />
                  <img
                    src={slide.img3}
                    alt=""
                    className="w-[23%] object-contain"
                  />
                </div>
                <div className="absolute top-[0rem] sm:top-[-2.5rem] right-[2rem] lg:right-[-1rem] lg:left-[22rem] md:left-[26rem] cursor-pointer flex ">
                  <KeyboardArrowLeftIcon
                    style={{ fontSize: 40 }}
                    onClick={prev}
                  />
                  <KeyboardArrowRightIcon
                    style={{ fontSize: 40 }}
                    onClick={next}
                  />
                </div>
              </div>
              <div className="max-w-[31rem] sm:pt-[0rem] pt-[2rem] ">
                <h2 className="font-bold text-xl mb-1 text-white px-3">
                  {slide.heading}
                </h2>
                <p className="text-sm px-3">{slide.para}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RoleCsrComponent;
